import React from "react";
import Tooltip from "../Tooltip";
import { mergeStyles } from "../../utils/utilStyles";
import useIsMobile from "../../hooks/useIsMobile";

const baseStyle = {
  backgroundColor: "bg-slate-200",
  textColor: "text-black",
  selectedColor: "bg-light-primary",
  selectedTextColor: "text-ov-gray-200",
  defaultColor: "bg-slate-300",
  disabledTextColor: "text-ov-gray-400",
  disabledBackgroundColor: "",
  hoverBackgroundColor: "md:hover:bg-slate-100",
};

const SelectionListField = ({
  title,
  options,
  disabledOptions,
  selectedOptions,
  setSelectedOptions,
  selectType = "single",
  overrideStyle = {},
}) => {
  const isMobile = useIsMobile();

  const onOptionClick = (option) => {
    if (isDisabled(option)) return;
    if (selectType === "single") {
      if (selectedOptions.some((selectedOption) => selectedOption.key === option)) {
        setSelectedOptions([]);
      } else {
        setSelectedOptions([{ key: option, type: "selected" }]);
      }
    } else {
      if (selectedOptions.some((selectedOption) => selectedOption.key === option)) {
        setSelectedOptions(selectedOptions.filter((selectedOption) => selectedOption.key !== option));
      } else {
        setSelectedOptions([...selectedOptions, { key: option, type: "selected" }]);
      }
    }
  };

  const isDisabled = (option) => {
    return disabledOptions.some((disabledOption) => disabledOption.option === option);
  };

  const mergedStyle = mergeStyles(baseStyle, overrideStyle);

  return (
    <div className="w-full flex flex-col md:flex-row gap-4 items-start md:items-center">
      <div className="flex gap-2 items-center justify-center">
        <span className="text-[12px] md:text-[14px]">{title}</span>
        <Tooltip
          direction="top"
          text={`Assign a ${title.toLowerCase()} to this contact, allowing callers to directly reach them by pressing this key. Consider updating the receptionist opening to reflect this dial key to your callers.`}
        />
      </div>
      <div
        className={`w-full md:w-auto md grid grid-cols-6 md:grid-cols-12 gap-2 ${mergedStyle.backgroundColor} p-1 rounded-md`}
      >
        {options.map((option, index) => {
          return (
            <Tooltip
              key={index}
              width="w-40"
              direction={"top"}
              textAlignment="text-center"
              showOnSmallDevices={true}
              text={
                isDisabled(option)
                  ? disabledOptions.find((disabledOption) => disabledOption.option === option).disabledBy
                  : ""
              }
            >
              <div
                onClick={() => onOptionClick(option)}
                className={`flex justify-center items-center px-3 py-1 rounded-md  ${mergedStyle.textColor}
            ${
              isDisabled(option)
                ? `${mergedStyle.disabledTextColor} ${mergedStyle.disabledBackgroundColor} pointer-events-none`
                : "cursor-pointer"
            }
            ${
              selectedOptions.some(
                (selectedOption) => selectedOption.key === option && selectedOption.type === "selected"
              )
                ? `${mergedStyle.selectedColor} hover:${mergedStyle.selectedColor}`
                : selectedOptions.some(
                    (selectedOption) => selectedOption.key === option && selectedOption.type === "default"
                  )
                ? `${mergedStyle.defaultColor} hover:${mergedStyle.defaultColor}`
                : `${mergedStyle.hoverBackgroundColor}`
            }
            `}
              >
                <span className="text-md text-center">{option}</span>
              </div>
            </Tooltip>
          );
        })}
      </div>
    </div>
  );
};

export default SelectionListField;
